define(['jquery', 'forms', 'responsive_common', 'erv_breakpoints', 'expand_collapse'], function ($, Forms, ERVResponsiveCommon, erv_breakpoints, ExpandCollapse) {

	var ERVTriggers = function () {
		var self = this;
		self.forms = new Forms();
        self.responsiveCommon = new ERVResponsiveCommon();
        self.$ervBody = $('#erv-body');
		self.isLargeDevice = function () { return self.responsiveCommon.getDeviceSize() === erv_breakpoints["large-min-width"]; }
		self.initTogglers = function (selector) {
			//used for menu (main menu/device menu) and footer (in small)
			var $expandTriggers = self.$ervBody.find(selector + ' [data-js="expandtrigger"]');
			$expandTriggers.on('click',
				function (e) {
					self.execTrigger($(this), $expandTriggers, e);
				});

			$expandTriggers.on('keydown', function (e) {
				if (e.key === 'Enter') {
					$(this).trigger('click');
				}
			});

			$expandTriggers.each(function () {
				var $this = $(this), $linkList = $this.parent();
				if ($linkList.find('ul').length && $linkList.find('ul').children().length && $linkList.parents('.sub-list').length === 0) {
					var $children = $linkList.find('ul').children();
					if ($children.length > 1 && !$this.hasClass('no-arrow') || $this.hasClass('allow-single-link') && $children.length > 0) {
						$this.addClass('arrow');
					}

					if ($this.hasClass('mainmenu') && !('ontouchstart' in window)) {
						$this.on('mouseenter', function (e) {
							if ($children.length == 1) {
								$expandTriggers.parent().removeClass('is-expanded');
								$(document).trigger("expandtrigger", { expanded: false, item: $this });
							}
							else if (!$linkList.hasClass('is-expanded')) {
								self.execTrigger($this, $expandTriggers, e);
							}
						});
						$('#header').on('mouseleave', function (e) {
							if ($linkList.hasClass('is-expanded')) {
								self.execTrigger($this, $expandTriggers, e);
							}
						});
					}
				}
			});
		};

		self.getCorrectLeftMarginValue = function($element) {
            var offsetLeft = $element.offset().left;
			var offsetRight = ($(window).width() - (offsetLeft + $element.outerWidth()));
			if(offsetRight >= 0 && offsetLeft >= 0) {
				return;
			}

            if (offsetLeft < 0) {
                return -offsetLeft;
            }
            if (offsetRight < 0) {
                return offsetRight;
            }
        }

		self.preventWindowOverflow = function($element) {
			if (!self.isLargeDevice()) {
                return;
            }
			var leftMargin = self.getCorrectLeftMarginValue($element);
			if (leftMargin) {
				return $element.css("margin-left", leftMargin + "px");
			}
        }

		self.execTrigger = function ($trigger, $expandTriggers, e) {
			e.stopPropagation();

			var $parent = $trigger.parent(),
				$listItems = $parent.find('ul li');

			$(document).trigger("expandtrigger", { expanded: $parent.hasClass('is-expanded'), item: $trigger });
			if ($listItems.length === 1 && !$trigger.hasClass('allow-single-link')) {
				window.location = $listItems.first().find('a').attr('href');
			} else if ($listItems.length > 1 || $trigger.hasClass('allow-single-link') && $listItems.length > 0) {
				$parent.toggleClass('is-expanded');
				$parent.find('.fade-in').removeClass('fade-in').removeAttr('style');
				$expandTriggers.not($trigger).parent().removeClass('is-expanded');
				var $sublist = $parent.find('.sub-list');

				if ($sublist.length) {
					if ($parent.hasClass('is-expanded')) {
						$sublist.outerWidth(); //reflow
                        self.preventWindowOverflow($sublist);
                        $sublist.addClass('fade-in');
					}
				} else {
					var $list = $trigger.parent().find('> ul');
					$list.outerWidth(); //reflow
                    self.preventWindowOverflow($list);

					if ($parent.hasClass('is-expanded')) {
						$list.addClass('fade-in');
					}
				}
			}
		};

		self.initTriggers = function (selector) {
			//used for menue (main menu/device menu) and footer (in small)
			var $expandTriggers = self.$ervBody.find(selector + ' [data-js="expandtrigger"]');

			$expandTriggers.on('click',
				function (e) {
					e.preventDefault();
					e.stopPropagation();

					var $trigger = $(this);
					var $iconContainer = $trigger.find('span');
					var $container = $trigger.parent().find('[data-js="expandcontainer"]');
					$container.toggleClass('hide');

					if ($container.hasClass('hide')) {
						$iconContainer.addClass('ergoicon-arrowthickdown');
						$iconContainer.removeClass('ergoicon-arrowthickup');
					} else {
						$iconContainer.addClass('ergoicon-arrowthickup');
						$iconContainer.removeClass('ergoicon-arrowthickdown');
					}
				});
		};

		self.initDropDowns = function () {
			$(document).on('ervShowDropdown', function (e) {
				var $ul = e.dropdown.children('.dropdown-menu');
				var $toggle = e.dropdown.children('.dropdown-toggle');
				var ulOffset = $ul.offset();
				var spaceUp = (ulOffset.top - $toggle.height() - $ul.height()) - $(window).scrollTop();
				var spaceDown = $(window).scrollTop() + $(window).height() - (ulOffset.top + $ul.height());
				if (spaceDown < 0 && (spaceUp >= 0 || spaceUp > spaceDown)) {
					$ul.css('top', -($ul.height()) - 25);
				} else {
					$ul.css('top', '');
				}
			}).on('ervHideDropdown', function (e) {
				var $ul = e.dropdown.children('.dropdown-menu');
				$ul.css('top', '');
			});

			$(document).on('click', '[data-js="dropdown-toggle"]', function (e) {
				e.preventDefault();

				var $dropDown = $(this).parents('.dropdown');
				if ($dropDown.hasClass('open')) {
					$dropDown.removeClass('open');
					$(document).trigger({
						type: 'ervHideDropdown',
						dropdown: $dropDown
					});
				} else {
					self.$ervBody.find('.dropdown.open').removeClass('open dropup');
					$dropDown.addClass('open');
					$(document).trigger({
						type: 'ervShowDropdown',
						dropdown: $dropDown
					});
				}
			});

			$(document).mouseup(function (e) {
				var $containers = self.$ervBody.find('.dropdown');

				$containers.each(function () {
					var $container = $(this);

					if (!$container.is(e.target) && $container.has(e.target).length === 0) {
						$container.removeClass('open dropup');
						$(document).trigger({
							type: 'ervHideDropdown',
							dropdown: $container
						});
					}
				});
			});
		};
	};

	ERVTriggers.prototype.init = function() {
		var self = this;

		self.initTogglers('nav');
		self.initTriggers();
		self.initDropDowns();
		ExpandCollapse.initExpandCollapse();

		self.$ervBody.find('[data-js=trigger-print]').on('click', function (e) {
			e.preventDefault();
			window.print();
		});
	};

	return ERVTriggers;
});